module.exports = __webpack_public_path__ + "static/img/17伊洛.8adee95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/17伊洛.jpg
// module id = oJLU
// module chunks = 1